import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, ConfigProvider } from "antd";
import useInterval from "use-interval";
import { useTranslation } from "react-i18next";
import "moment-timezone";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
 
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardMenu from "components/layout/sidebar/DefaultSidebarOptions";
import VerificationMenu from "components/layout/sidebar/VarificationSidebarOptions";
import TopNotificationBar from "features/dashboard/components/TopNotificationBar";
import { useGetSettingsMutation } from "redux/settings/settingsSlice";
import NavBar from "features/dashboard/components/NavBar";
 
import TopNavbar from "components/layout/nav/Navbar";
import WhatsAppButton from "components/WhatsAppButton";
import AddStoreModel from "features/dashboard/components/AddStoreModel";

import { CONSTANTS as C } from "config";
import { API } from "api";
import { UTILS } from "utils";
import { Language } from "redux/actions";
import { PkgActions } from "redux/actions";
import { SettingsAction } from "redux/actions";
 
const DashboardLayout = (props) => {
  const history = useHistory();
  const { isLoggedIn } = useSelector((state) => state.LoginReducer);
  const [getSettings] = useGetSettingsMutation();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isNotificationBarVisible, packageText } = useSelector(
    (state) => state.PackagesReducer
  );
 
  const checkvalidity = async () => {
    const { text, notify } = await UTILS.checkPackageValidity();
    dispatch(PkgActions.setNotifyVisible(notify));
    dispatch(PkgActions.setPackText(text));
  };
 
  const getIntegrations = async () => {
    const userDetail = UTILS.getCurrentUser();
    const response = await API.GET_INTEGRATIONS({
      brandId: userDetail.brandId,
    });
    if (response?.success === 1) {
      dispatch(SettingsAction.setIntegrations(response?.data));
    }
    // getting settings for brands
    getSettings({
      brandId: userDetail.brandId,
      language: "EN",
    });
  };
 
  useInterval(() => {
    async function getData() {
      const response = await UTILS.checkPackageValidity();
      if (response.result) {
        checkvalidity();
      }
    }
    getData();
  }, C.SIXHOURS);
 
  useEffect(() => {
    checkvalidity();
    getIntegrations();
  }, [isLoggedIn]);
 
  // Reset page breadcrumb when location changes
  useEffect(() => {
    dispatch(Language.setPageBreadCrumb([]))
  }, [location.pathname])
 
  const topics = ["First topic", "Second topic", "Third topic"];
  const [contentIndex, setContentIndex] = useState(0);
  const [selectedKey, setSelectedKey] = useState("0");
  const changeSelectedKey = (event) => {
    const key = event.key;
    setSelectedKey(key);
    setContentIndex(+key);
  };
  const [visible, setVisible] = useState(false);
  const [hasStore, setHasStore] = useState(true);
  const [checkingStores, setCheckingStores] = useState(true);

  const getCurrentUserStores = async () => {
    try {
      setCheckingStores(true);
      const userDetail = UTILS.getCurrentUser();
      const result = await API.GET_CRRENT_USER_STORES({
        token: userDetail?.token,
        language: "EN",
      });
      const hasAnyStore =
        result?.success === 1 &&
        Array.isArray(result?.data) &&
        result?.data?.length > 0;
      setHasStore(hasAnyStore);
    } catch (error) {
      setHasStore(true);
    } finally {
      setCheckingStores(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) getCurrentUserStores();
  }, [isLoggedIn]);

  const exemptNoStoreRoutes = [
    "/app/dashboard/onboarding",
    "/app/dashboard/addstore",
  ];
  const shouldShowNoStoreModal =
    !checkingStores &&
    !hasStore &&
    !exemptNoStoreRoutes.some((route) => location.pathname.startsWith(route));
  const Menu = (
    <DashboardMenu
      setVisible={setVisible}
      topics={topics}
      selectedKey={selectedKey}
      changeSelectedKey={changeSelectedKey}
    />
  );
  const VerifyMenu = (
    <VerificationMenu
      setVisible={setVisible}
      topics={topics}
      selectedKey={selectedKey}
      changeSelectedKey={changeSelectedKey}
    />
  );
 
 
  return (
    <ConfigProvider direction={i18n?.language?.toUpperCase() === "AR" ? "rtl" : "ltr"}>
      <AddStoreModel
        open={shouldShowNoStoreModal}
        onClose={() => history.push("/app/dashboard/onboarding")}
      />
 
      {props?.layoutType === C.DASHBOARD_LAYOUT &&
        process.env.REACT_APP_COMPANY_NAME === C.COMPANY_NAMES.RESTHERO && (
          <div
            className={
              "sticky top-0 left-0 z-50 py-2 border-b w-full border-border-color bg-red-500 " +
              (isNotificationBarVisible ? "block" : "hidden")
            }
          >
            <TopNotificationBar text={packageText} />
          </div>
        )}
      <Layout style={{ backgroundColor: "#F0F2F4", minHeight: "100vh", display: "flex", padding:"24px", paddingTop:0 }}>
       <SideBar menu={props?.layoutType === C.VERIFICATION_LAYOUT ? VerifyMenu : Menu} />
        <Layout className="relative flex-1 min-w-0 lg:ps-6">
          <TopNavbar
            layoutType={props?.layoutType}
            packageText={packageText}
            isNotificationBarVisible={isNotificationBarVisible}
            component={ <NavBar menu={props?.layoutType === C.VERIFICATION_LAYOUT  ? VerifyMenu : Menu} visible={visible} setVisible={setVisible} />}
          />
          <div className="pt-3">
          {props.children}
          </div>
          {process.env.REACT_APP_COMPANY_NAME !== C.COMPANY_NAMES.CUSINETTE && (
            <WhatsAppButton />
          )}
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};
export default DashboardLayout;